/**
 * 브라우저 탭 제목 — "화면 · SignageOne", 상세는 "본사 1층 로비 · 화면 상세 · SignageOne".
 *
 * 예전에는 모든 탭이 "SignageOne 콘솔" 이라, 콘솔을 탭 여러 개로 열어 두면(화면 상세 셋, 활동 로그 하나)
 * 어느 탭이 무엇인지 하나씩 눌러 봐야 했다. 방문 기록·즐겨찾기에도 같은 이름만 줄줄이 남았다.
 *
 * 화면 이름은 레이아웃(`AdminLayout`)이 메뉴 표(`titleFor`)에서 정하고, 상세 화면은 대상의 이름을
 * 덧붙인다(`useTitleDetail`). 둘이 그리는 순서와 상관없이 같은 제목이 되게 상세 이름은 여기 한 곳에 둔다.
 */
import { useEffect, useSyncExternalStore } from 'react';

export const PRODUCT = 'SignageOne';

export function documentTitle(label: string, detail: string | null = null): string {
  // 메뉴 표에 없는 경로는 이름이 제품 이름이다 — "SignageOne · SignageOne" 으로 겹치지 않게.
  const page = label === PRODUCT ? null : label;
  return [detail, page, PRODUCT].filter((part): part is string => Boolean(part)).join(' · ');
}

let current: { path: string; name: string } | null = null;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** 레이아웃이 읽는다 — 지금 경로에 붙은 상세 이름. 다른 경로의 것이면 무시한다(떠나는 중). */
export function useTitleDetailFor(path: string): string | null {
  const detail = useSyncExternalStore(subscribe, () => current);
  return detail && detail.path === path ? detail.name : null;
}

/** 상세 화면이 대상 이름을 탭 제목에 붙인다. 이름을 모르면(읽는 중) 붙이지 않는다. */
export function useTitleDetail(path: string, name: string | null | undefined): void {
  useEffect(() => {
    if (!name) return;
    current = { path, name };
    for (const listener of listeners) listener();
    return () => {
      if (current?.path === path && current.name === name) {
        current = null;
        for (const listener of listeners) listener();
      }
    };
  }, [path, name]);
}
